<template>
  <div id="performanceSetting">
    <div class="top">
      <p v-wave class="tabName" :class="item.status ? 'tabNameActive' : ''" v-for="item in tabList" :key="item.value" @click="tabChange(item)">
        {{$t(item.name)}}
      </p>
    </div>
    <div class="bottom">
      <div class="left">
        <div class="fastSelect">
          <h4>{{ $t('快速选择') }}</h4>
          <el-button-group>
            <el-button v-wave type="primary" @click="fastSelect('1')">{{ $t('全选') }}</el-button>
            <el-button v-wave type="primary" @click="fastSelect('2')">WASD</el-button>
            <el-button v-wave type="primary" @click="fastSelect('3')">{{ $t('数字') }}</el-button>
            <el-button v-wave type="primary" @click="fastSelect('4')">A - Z</el-button>
            <el-button v-wave type="primary" @click="fastSelect('5')">{{ $t('反选') }}</el-button>
            <el-button v-wave type="primary" @click="fastSelect('6')">{{ $t('取消') }}</el-button>
          </el-button-group>
        </div>
        <div v-show="tabList[0].status" class="sliderBox">
          <p class="tips">
            {{ $t('提示内容4') }}
          </p>
          <div class="slider">
            <h4>{{ $t('滑块标题1') }}</h4>
            <el-slider :show-tooltip="false" show-input  v-model="ordinaryMode.itinerary" :min="0.1" :max="4.00" :step="0.01" @change="sliderChange('1')"></el-slider>
          </div>
          <div class="slider">
            <h4>{{ $t('滑块标题2') }}</h4>
            <el-slider :show-tooltip="false" show-input v-model="ordinaryMode.resilience" :min="0.1" :max="4.00" :step="0.01" @change="sliderChange('2')"></el-slider>
          </div>
        </div>
        <div v-show="tabList[1].status" class="sliderBox">
          <p class="tips">
            {{ $t('提示内容5') }}
          </p>
          <div class="switch">
            <h4>{{ $t('滑块标题3') }}</h4>
            <el-switch v-model="fastMode.smallerSteps" inactive-color="#888888"></el-switch>
          </div>
          <div v-show="fastMode.showRT" class="switch" style="margin-top: 0.2rem">
            <h4>{{ $t('滑块标题4') }}</h4>
            <el-switch v-model="fastMode.lessThan" inactive-color="#888888" @change="lessThanChange"></el-switch>
          </div>
          <div v-show="fastMode.showRT" class="switch" style="margin-top: 0.2rem">
            <el-alert
              :title="$t('温馨提示')"
              type="warning"
              :closable="false"
              :description="$t('提示内容6')"
              show-icon>
            </el-alert>
          </div>
        </div>
        <div v-show="tabList[2].status" class="sliderBox">
          <p class="tips">
            {{ $t('提示内容7') }}
          </p>
        </div>
      </div>
      <el-divider direction="vertical"></el-divider>
      <div class="right">
        <div v-show="tabList[0].status" class="sliderBox">
          <div class="switch">
            <h4>{{ $t('滑块标题5') }}</h4>
            <el-switch v-model="ordinaryMode.isEqual" inactive-color="#888888"></el-switch>
          </div>
        </div>
        <div v-show="tabList[1].status" class="sliderBox">
          <div class="switch" style="margin-bottom: 0.2rem">
            <h4>{{$t('滑块标题11')}}</h4>
            <el-switch v-model="fastMode.showRT" inactive-color="#888888"></el-switch>
          </div>
          <div class="slider" v-show="!fastMode.showRT">
            <h4>{{$t('滑块标题10')}}</h4>
            <el-slider :show-tooltip="false" show-input v-model="fastMode.RTPrecision" :min="fastMode.lessThan ? 0.01 : 0.1" :max="1.00" :step="fastMode.smallerSteps ? 0.005 : 0.01" @change="sliderChange('7')"></el-slider>
          </div>
          <div class="slider" v-show="fastMode.showRT">
            <h4>{{ $t('滑块标题6') }}</h4>
            <el-slider :show-tooltip="false" show-input v-model="fastMode.quickTrigger" :min="fastMode.lessThan ? 0.01 : 0.1" :max="1.00" :step="fastMode.smallerSteps ? 0.005 : 0.01" @change="sliderChange('3')"></el-slider>
          </div>
          <div class="slider" v-show="fastMode.showRT">
            <h4>{{ $t('滑块标题7') }}</h4>
            <el-slider :show-tooltip="false" show-input v-model="fastMode.quickResilience" :min="fastMode.lessThan1" :max="1.00" :step="fastMode.smallerSteps ? 0.005 : 0.01" @change="sliderChange('4')"></el-slider>
          </div>
          <div class="slider">
            <h4>{{ $t('滑块标题8') }}</h4>
            <el-slider :show-tooltip="false" show-input v-model="fastMode.topDead" :min="0.055" :max="1.00" :step="fastMode.smallerSteps ? 0.005 : 0.01" @change="sliderChange('5')"></el-slider>
          </div>
          <div class="slider">
            <h4>{{ $t('滑块标题9') }}</h4>
            <el-slider :show-tooltip="false" show-input v-model="fastMode.bottomDead" :min="0" :max="1.00" :step="fastMode.smallerSteps ? 0.005 : 0.01" @change="sliderChange('6')"></el-slider>
          </div>
        </div>
        <div v-show="tabList[2].status" class="selectBox">
          <div class="bodyBox">
            <h4>{{ $t('轴体选择') }}</h4>
            <div class="bodyBoxItemBox">
              <p v-wave v-for="item in keyBodyList" :key="item.value" @click="keyBodyChange(item)" class="bodyBoxItem" :class="[item.status ? 'bodyBoxItemActive' : '']">
                <span class="colorBox" :style="{background:item.color}"></span>
                <span class="nameBox">{{$t(item.label)}}</span>
              </p>
            </div>
            <p style="margin-top: 0.2rem;font-size: 0.15rem;"><span>{{ $t('轴体行程') }}：</span>{{keyBodyJourney}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/store/eventBus";

export default {
  name: "performanceSetting",
  data() {
    return {
      isConnected: false,
      tabList:[
        {
          name: '普通模式',
          value: '0',
          status: true
        },
        {
          name: '快速触发',
          value: '1',
          status: false
        },
        {
          name: '轴体设置',
          value: '2',
          status: false
        }
      ],
      // 普通模式触发值回弹值对象
      ordinaryMode: {
        itinerary: 1.6, // 触发值
        resilience: 0.8, // 回弹值
        isEqual: false // 是否允许触发值接近或等于回弹值
      },
      fastMode: {
        showRT: false, // 单独设置rt触发值和rt回弹值
        RTPrecision: 0.5, // rt精度
        smallerSteps: true, // 是否开启更小步进
        lessThan: true, // 是否允许触发距离小于0.01
        lessThan1: 0.01, // 判断回弹距离的下限
        mornThen: 4.00, // 回弹距离的上限 默认4
        quickTrigger: 0.5, // 快速触发值
        quickResilience: 0.5, // 快速回弹值
        topDead: 0.1, // 顶部死区
        bottomDead: 0.1, // 底部死区
      },
      keyBodyJourney: '3.375mm',
      keyBodyList: [
        {
          value: 1,
          label: '万磁王轴(新)',
          des: '3.375mm',
          status: true,
          color: '#de858e'
        },
        {
          value: 0,
          label: '万磁王轴',
          des: '3.42mm',
          status: false,
          color: '#F65060FF'
        },
        {
          value: 2,
          label: '磁玉轴pro',
          des: '3.42mm',
          status: false,
          color: '#F1DEC6'
        },
        // {
        //   value: 3,
        //   label: '封底磁珀轴',
        //   des: '3.78mm',
        //   status: false,
        //   color: '#ffd200'
        // }
      ],
      notificationVisible: false, // 警告提醒是否可见
    }
  },
  mounted() {
    EventBus.$on('connected', this.getConnectedResult)
    EventBus.$on('backDisplay',this.backDisplay)
  },
  methods: {
    // 获取键盘连接状态回调
    getConnectedResult(val) {
      this.isConnected = val
    },
    // 快速选择
    fastSelect(val) {
      EventBus.$emit('fastSelect',val)
    },
    tabChange(obj) {
      this.tabList.forEach(e => {
        if (obj.value === e.value) {
          e.status = true
          if (this.isConnected) {
            EventBus.$emit('settingTabChange',{
              perRadio: e.value,
              itinerary: this.ordinaryMode.itinerary,
              resilience: this.ordinaryMode.resilience,
              quickTrigger: this.fastMode.quickTrigger,
              quickResilience: this.fastMode.quickResilience,
              topDead: this.fastMode.topDead,
              bottomDead: this.fastMode.bottomDead,
              smallerSteps: this.fastMode.smallerSteps
            })
          }
        } else {
          e.status = false
        }
      })
    },
    lessThanChange() {
      if (this.fastMode.quickTrigger < 0.1 && !this.fastMode.lessThan) {
        this.fastMode.quickTrigger = 0.1
      }
      EventBus.$emit('sliderChange', {
        sign: '3',
        perRadio: '2',
        itinerary: this.ordinaryMode.itinerary,
        resilience: this.ordinaryMode.resilience,
        quickTrigger: this.fastMode.quickTrigger,
        quickResilience: this.fastMode.quickResilience,
        topDead: this.fastMode.topDead,
        bottomDead: this.fastMode.bottomDead,
        smallerSteps: this.fastMode.smallerSteps

      })
    },
    sliderChange(sign){
      if (sign === '1' || sign === '2') {
        if (this.ordinaryMode.itinerary >= 0.15) {
          if (this.ordinaryMode.itinerary < this.ordinaryMode.resilience) { // 触发小于回弹，更改回弹的值
            if (this.ordinaryMode.isEqual) { // 允许回弹等于触发
              this.ordinaryMode.resilience = this.ordinaryMode.itinerary
            } else {
              this.ordinaryMode.resilience = Math.round((this.ordinaryMode.itinerary - 0.1) * 100) / 100
            }
            this.$notify.info({
              title: this.$t('提示'),
              message: this.$t('提示内容8'),
              offset: 100
            })
          } else {
            if ((this.ordinaryMode.itinerary - this.ordinaryMode.resilience) < 0.1) {
              if (!this.ordinaryMode.isEqual) { // 不允许回弹等于触发
                this.ordinaryMode.resilience = Math.round((this.ordinaryMode.itinerary - 0.1) * 100) / 100
              }
            }
          }
        } else {
          this.ordinaryMode.isEqual = true
          if (this.ordinaryMode.itinerary < this.ordinaryMode.resilience) {
            this.ordinaryMode.resilience = this.ordinaryMode.itinerary
            this.$notify.info({
              title: this.$t('提示'),
              message: this.$t('提示内容8'),
              offset: 100
            })
          }
        }
      }
      if (sign === '7') { //rt精度
        this.fastMode.quickTrigger = this.fastMode.RTPrecision
        this.fastMode.quickResilience = this.fastMode.RTPrecision
      }
      if (sign === '3' || sign === '4') {
        if (this.fastMode.quickTrigger >= this.fastMode.quickResilience) {
          this.fastMode.RTPrecision = this.fastMode.quickTrigger
        } else {
          this.fastMode.RTPrecision = this.fastMode.quickResilience
        }
      }
      if (this.isConnected) {
        EventBus.$emit('sliderChange', {
          sign: sign,
          perRadio: (sign === '1' || sign === '2') ? '1' : '2',
          itinerary: this.ordinaryMode.itinerary,
          resilience: this.ordinaryMode.resilience,
          quickTrigger: this.fastMode.quickTrigger,
          quickResilience: this.fastMode.quickResilience,
          topDead: this.fastMode.topDead,
          bottomDead: this.fastMode.bottomDead,
          smallerSteps: this.fastMode.smallerSteps

        })
        let bol = false
        if (sign === '3' && Number(this.fastMode.quickTrigger) <= 0.1) {
          bol = true
        }
        if (sign === '4' && Number(this.fastMode.quickResilience) <= 0.1) {
          bol = true
        }
        if(bol) {
          if (this.notificationVisible) {
            return;
          }
          // 标记通知为可见
          this.notificationVisible = true;
          const h = this.$createElement;
          this.$notify({
            title: this.$t('警告'),
            message: h('i', { style: 'color: teal'}, this.$t('提示内容9')),
            offset: 100,
            position: 'left',
            type: 'warning',
            onClose: () => {
              // 通知关闭时，将标识重置为 false
              this.notificationVisible = false;
            }
          });
        }
      }
    },
    keyBodyChange(obj) {
      this.keyBodyList.forEach(e => {
        if (obj.value === e.value) {
          e.status = true
          this.keyBodyJourney = e.des
          EventBus.$emit('selectKeyBody',e.value)
        } else {
          e.status = false
        }
      })
    },
    backDisplay(obj) {
      if(obj.mode === '1') {
        if (['0','1'].includes(obj.functionMenu)) {
          this.tabList[0].status = true
          this.tabList[1].status = false
        }
        let minObject = obj.list.reduce((minObj, currentObj) => {
          // 检查当前对象的field字段是否大于最大值对象的field字段
          if (currentObj.trigger < minObj.trigger) {
            return currentObj; // 如果是，返回当前对象作为新的最大值对象
          } else {
            return minObj; // 否则，保持原最大值对象不变
          }
        }, obj.list[0])
        this.ordinaryMode.itinerary = minObject.trigger/1000
        this.ordinaryMode.resilience = minObject.resilient/1000
        this.ordinaryMode.isEqual = (Math.round((this.ordinaryMode.itinerary - this.ordinaryMode.resilience) * 100) / 100) < 0.1
      } else if(obj.mode === '2') {
        if (['0','1'].includes(obj.functionMenu)) {
          this.tabList[0].status = false
          this.tabList[1].status = true
        }
        let minObject = obj.list1.reduce((minObj, currentObj) => {
          if (currentObj.press < minObj.press) {
            return currentObj;
          } else {
            return minObj;
          }
        }, obj.list1[0])
        this.fastMode.RTPrecision = minObject.press/1000
        this.fastMode.quickTrigger = minObject.press/1000
        this.fastMode.quickResilience = minObject.returnVal/1000
        this.fastMode.topDead = minObject.topPressDead/1000
        this.fastMode.bottomDead = minObject.bottomPressDead/1000
        if (this.fastMode.quickTrigger < 0.1) {
          this.fastMode.lessThan = true
        }
      }
      if (obj.body.includes(2)) { // 选中的按键当中包含磁玉pro
        this.fastMode.lessThan1 = 0.015
        this.fastMode.mornThen = 3.42
      } else {
        if (obj.body.includes(1)) { // 选中的按键当中包含万磁王新但是不包含磁玉pro
          this.fastMode.lessThan1 = 0.01
          this.fastMode.mornThen = 3.375
        } else {
          if (obj.body.includes(0)) { // 包含万磁王
            this.fastMode.lessThan1 = 0.01
            this.fastMode.mornThen = 3.42
          } else { // 只有磁珀
            this.fastMode.lessThan1 = 0.03
            this.fastMode.mornThen = 3.78
          }
        }
      }
      this.fastMode.showRT = obj.mode1 === '1';
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../style/handle.scss';
  #performanceSetting {
    width: 100%;
    .top {
      display: flex;
      justify-content: center;
      margin-bottom: 0.1rem;
      border-bottom: 0.03rem solid;
      @include border_color('border-bottom-color');
      height: 0.5rem;
      .tabName {
        width: 3rem;
        height: 0.5rem;
        font-weight: 700;
        //line-height: 40px;
        text-align: center;
        margin-right: 0.05rem;
        //box-shadow: 0 5px 12px rgba(0,0,0,0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.15rem;
      }
      .tabNameActive {
        color: #409EFF;
        border-bottom: 0.03rem solid #409EFF;
      }
    }
    .bottom {
      display: flex;
      height: 4.9rem;
      .left {
        width: 50%;
        .sliderBox {
          padding: 0.2rem;
          width: 100%;
          .tips {
            margin: 0.2rem 0;
            color: #888888;
            max-width: 80%;
            font-size: 0.15rem;
          }
          .slider {
            margin-bottom: 0.4rem;
            h4 {
              font-size: 0.18rem;
            }
          }
          .switch {
            display: flex;
            justify-content: space-between;
            align-items: center;
            /deep/.el-alert {
              padding: 0.08rem 0.16rem;
              border-radius: 0.04rem;
              .el-alert__icon.is-big {
                font-size: 0.28rem;
                width: 0.28rem;
              }
              .el-alert__content {
                padding: 0 0.08rem;
                .el-alert__title {
                  font-size: 0.13rem;
                  line-height: 0.18rem;
                }
                .el-alert__description {
                  font-size: 0.12rem;
                  margin: 0.05rem;
                }
              }
            }
            h4 {
              font-size: 0.15rem;
            }
            /deep/.el-switch {
              font-size: 0.14rem !important;
              line-height: 0.2rem !important;
              height: 0.2rem !important;
              .el-switch__label {
                height: 0.2rem;
                font-size: 0.14rem !important;
                span {
                  font-size: 0.14rem !important;
                }
              }
              .el-switch__label--left {
                margin-right: 0.1rem;
              }
              .el-switch__label--right {
                margin-left: 0.1rem;
              }
              .el-switch__core {
                width: 0.4rem !important;
                height: 0.2rem;
                border-radius: 0.1rem;
                border-width: 0.01rem;
              }
              .el-switch__core:after {
                top: 0.01rem;
                left: 0.01rem;
                width: 0.16rem;
                height: 0.16rem;
              }
            }
            /deep/.el-switch.is-checked .el-switch__core::after {
              margin-left: 0.19rem !important;
            }
          }
        }
        .fastSelect {
          padding: 0 0.2rem;
          h4 {
            margin-bottom: 0.1rem;
            font-size: 0.15rem;
          }
          .el-button-group {
            .el-button {
              width: 1rem;
              border-width: 0.01rem;
              padding: 0.12rem 0.2rem;
              font-size: 0.14rem;
              border-radius: 0.04rem;
            }
          }
        }
      }
      .el-divider--vertical {
        height: 100%;
        background-color: #888888;
        width: 0.01rem;
        margin: 0 0.08rem;
      }
      .right {
        width: 50%;
        .sliderBox {
          padding: 0.2rem;
          width: 100%;
          .switch {
            display: flex;
            justify-content: space-between;
            align-items: center;
            h4 {
              font-size: 0.15rem;
            }
            /deep/.el-switch {
              font-size: 0.14rem !important;
              line-height: 0.2rem !important;
              height: 0.2rem !important;
              .el-switch__label {
                height: 0.2rem;
                font-size: 0.14rem !important;
                span {
                  font-size: 0.14rem !important;
                }
              }
              .el-switch__label--left {
                margin-right: 0.1rem;
              }
              .el-switch__label--right {
                margin-left: 0.1rem;
              }
              .el-switch__core {
                width: 0.4rem !important;
                height: 0.2rem;
                border-radius: 0.1rem;
                border-width: 0.01rem;
              }
              .el-switch__core:after {
                top: 0.01rem;
                left: 0.01rem;
                width: 0.16rem;
                height: 0.16rem;
              }
            }
            /deep/.el-switch.is-checked .el-switch__core::after {
              margin-left: 0.19rem !important;
            }
          }
          .tips {
            margin: 0.2rem 0;
            color: #888888;
          }
          .slider {
            margin-bottom: 0.25rem;
            h4 {
              font-size: 0.18rem;
            }
          }
        }
        .selectBox {
          width: 100%;
          padding: 0 0.2rem;
          .bodyBox {
            h4 {
              font-size: 0.15rem;
            }
            .bodyBoxItemBox {
              display: flex;
              margin: 0.2rem 0;
              font-size: 0.132rem;
              .bodyBoxItem {
                width: 1.5rem;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 0.2rem;
                border: 0.02rem solid #888888;
                padding: 0.15rem;
                border-radius: 0.05rem;
                .colorBox {
                  display: inline-block;
                  width: 0.2rem;
                  height: 0.2rem;
                  background-color: #fff;
                  border-radius: 0.02rem;
                  margin-right: 0.1rem;
                }
                .nameBox {

                }
              }
              .bodyBoxItemActive {
                color: #409EFF;
                border-color: #409EFF !important;
              }
            }
          }
        }
      }
    }
  }
</style>
